// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608240059/js/" + chunkId + "." + {"44":"8274ff0a","225":"c7834b42","481":"268f7968","486":"071747f1","770":"7638d962"}[chunkId] + ".0.5896044497832182.chunk.js";
};